import React from "react";
import { useParams, Navigate, useNavigate } from "react-router-dom";

import ProjectDetails from "./ProjectDetails";

/* ===================================================== */
/* 🧱 Helpers                                             */
/* ===================================================== */

// Mongo ObjectId validation (24 hex chars)
const isValidObjectId = (id) =>
  typeof id === "string" && /^[a-f\d]{24}$/i.test(id);

/* ===================================================== */
/* 📄 PROJECT DETAILS PAGE                               */
/* ===================================================== */

export default function ProjectDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const projectId = id?.trim();

  /* ---------------- Invalid Param ---------------- */
  if (!projectId || !isValidObjectId(projectId)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="text-center space-y-3 max-w-sm">

          <h2 className="text-lg font-semibold text-gray-800">
            Invalid Project
          </h2>

          <p className="text-sm text-gray-500">
            The project you are trying to access does not exist or is invalid.
          </p>

          <button
            onClick={() => navigate("/projects")}
            className="mt-2 px-4 py-2 bg-black text-white rounded-lg text-sm hover:bg-gray-800"
          >
            Go to Projects
          </button>

        </div>
      </div>
    );
  }

  /* ---------------- Render ---------------- */
  return (
    <div className="min-h-screen bg-gray-50">
      <ProjectDetails projectId={projectId} />
    </div>
  );
}